import {Component, EventEmitter, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { VesselsService, NauticalMile } from 'src/app/transportation/vessels/vessels.service';
import { forkJoin } from 'rxjs';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import {PgTitleComponent} from '../../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';

@Component({
  selector: 'app-nautical-mile',
  templateUrl: './nautical-mile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AgGridModule]
})
export class NauticalMileComponent implements OnInit, PgTitleComponent {

  title = new EventEmitter<string>();

  ports!: Organisation[];
  selectedNauticalMile!: NauticalMile;
  port1!: string;
  port2!: string;
  distance!: number;
  importedData: NauticalMile[] = [];

  gridOptions: GridOptions = {};

  constructor(private _organisationService: OrganisationService,
              private _vesselsService: VesselsService,
              private _pgMessagesService: PgMessagesService) {
  }

  columnDefs = [
    {headerName:'Port1', field:'sourceOrganisationId',
      cellRenderer: (row: any) => this.formatPorts(row.value)
    },
    {headerName:'Port2', field:'destinationOrganisationId',
      cellRenderer: (row: any) => this.formatPorts(row.value)
    },
    {headerName:'Distance', field:'distance'},
  ];

  ngOnInit() {
    this.gridOptions = AgGridService.getOptions();
    this.title.emit('Nautical distances');
    forkJoin([
      this._organisationService.getPorts(),
      this._vesselsService.getNauticalMiles(),
    ]).subscribe(results => {
      this.ports = results[0].filter(p => p.properties['isPort']);
      this.importedData = results[1];
    });
    this.selectedNauticalMile = {
      sourceOrganisationId: '',
      destinationOrganisationId: '',
      distance: 0,
    };
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  add() {
    this.selectedNauticalMile = {
      sourceOrganisationId: this.port1,
      destinationOrganisationId: this.port2,
      distance: +this.distance,
    };
    this._vesselsService.addNauticalMile(this.selectedNauticalMile)
      .subscribe(() => {
        this.importedData.push(this.selectedNauticalMile);
        // this.datatableInit();
        this._pgMessagesService.publishMessage({
          message: `Distance ${this.distance} Imported`,
          topic: 'New Distance',
          level: MessageLevel.Info
        });
      }, () => {
        this._pgMessagesService.publishMessage({
          message: 'Error happened while importing this distance',
          topic: 'Import Nautical mile',
          level: MessageLevel.Error
        });
      });
  }

  formatPorts(portOrganisationId: string) {
    const port = this.ports.find(p => p.name === portOrganisationId);
    return (port !== undefined) ? port.nameTranslations['en'] : '';
  }
}
